import React, { useCallback, useState } from 'react';
import { Form, InputNumber, Button, Checkbox, DatePicker } from 'antd';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { fetchStocksByOrganizationModule } from '@resources/Stock/actions';
import { formErrorHandler } from '@common/utils/form';
import moment from 'moment';

const FormItem = Form.Item;

const RentalForm = (props) => {
	const { module, data, onSubmit, match, onCancel, organization } = props;
	const intl = useIntl();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const handleFinish = useCallback(
		(values) => {
			setLoading(true);

			if (organization?._id) {
				values['organization'] = organization?._id;
			}

			if (module) {
				values['module'] = module._id;
				values[module.code] = match?.params[`moduleId`];
			}

			onSubmit(values)
				.then(() => setLoading(false))
				.catch((err) => {
					setLoading(false);
					formErrorHandler(err, values, form);
				});
		},
		[onSubmit, organization]
	);

	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	};

	return (
		<Form
			form={form}
			layout="vertical"
			name="position-form"
			onFinish={handleFinish}
			initialValues={{ ...data, item: data?.item?._id }}>
			<FormItem
				label={intl.formatMessage({
					id: 'common.qty',
					defaultMessage: 'Qty',
				})}
				name={'quantity'}
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.quantity.required',
							defaultMessage: 'Please input quantity',
						}),
					},
				]}>
				<InputNumber
					min={0}
					placeholder={intl.formatMessage({
						id: 'common.hours',
						defaultMessage: 'Hours',
					})}
				/>
			</FormItem>

			<FormItem
				label={intl.formatMessage({
					id: 'common.date',
					defaultMessage: 'Date',
				})}
				name="date"
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.date.required',
							defaultMessage: 'Please input date',
						}),
					},
				]}>
				<DatePicker disabledDate={disabledDate} />
			</FormItem>

			<FormItem
				label={intl.formatMessage({
					id: 'common.duration',
					defaultMessage: 'Duration',
				})}
				name="duration"
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.duration.required',
							defaultMessage: 'Please input duration',
						}),
					},
				]}>
				<InputNumber
					placeholder={intl.formatMessage({
						id: 'common.hours',
						defaultMessage: 'Hours',
					})}
				/>
			</FormItem>

			<FormItem name="isActive" valuePropName="checked">
				<Checkbox>
					{intl.formatMessage({
						id: 'common.isActive',
						defaultMessage: 'Is Active',
					})}
				</Checkbox>
			</FormItem>
			<FormItem className="mt-5">
				<Button type="secondary" onClick={() => onCancel()}>
					{intl.formatMessage({
						id: 'common.cancel',
						defaultMessage: 'Cancel',
					})}
				</Button>
				&nbsp;&nbsp;
				<Button
					loading={loading}
					type="primary"
					htmlType="submit"
					className="login-form-button">
					{intl.formatMessage({
						id: 'common.submit',
						defaultMessage: 'Submit',
					})}
				</Button>
			</FormItem>
		</Form>
	);
};

const mapStateToProps = ({ auth, stocks, organization }) => {
	return {
		auth,
		stocks,
		organization,
	};
};

export default connect(mapStateToProps, { fetchStocksByOrganizationModule })(
	RentalForm
);
